module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/53rvFHqaD0JNzQKeWQUSIw-9fb0f42ea9cc8df3021159d0aad3f326.jpg";